import SelectorEngine from '../../../utils/dom/selector-engine';
import Modal from '../../../components/Modal';
import attachValidation from '../../../utils/form-validation';
import { getDataFromForm } from '../../../utils/misc';
import { startLoadingAnimation, stopLoadingAnimation } from '../../../utils/dom/loading';
import EventHandler from '../../../utils/dom/event-handler';
import Manipulator from '../../../utils/dom/manipulator';
import Request from '../../../utils/request';

class OfficialsEditEmailAddress {
	constructor() {
		this._container = SelectorEngine.findOne('.js-edit-officials-details-email-address-details');
		this.toggleStatus = undefined;

		if (this._container) {
			this.init();
		}
	}

	init() {
		this._form = SelectorEngine.findOne('#lta-officials-details__edit-email-address-form', this._container);
		this._exitModal = new Modal(SelectorEngine.findOne('#officials-details-email-address-exit', this._container), {});

		this._cancelCta = SelectorEngine.findOne('.lta-officials-details__edit-email-address-back', this._container);
		this._cancelCta.addEventListener('click', () => this._exitModal.show());

		const popupCancel = SelectorEngine.findOne('.lta-officials-details__edit-email-address-continue', this._container);
		popupCancel.addEventListener('click', () => this._exitModal.hide());

		const popupContinue = SelectorEngine.findOne('.lta-officials-details__edit-email-address-exit', this._container);
		popupContinue.addEventListener('click', (event) => this.backToUrl(event));

		this._errorContainer = SelectorEngine.findOne('.lta-officials-details__edit-email-address-error', this._container);
		this._errorContainerCta = SelectorEngine.findOne(
			'.lta-officials-details__edit-email-address-error-btn',
			this._errorContainer
		);

		this._errorContainerCta.addEventListener('click', () => this._errorContainer.classList.add('u-hidden'));

		this.fv = attachValidation(this._form, {
			email: {
				validators: {
					notEmpty: {
						message: 'Please enter an email address'
					},
					regexp: {
						regexp:
							// eslint-disable-next-line no-useless-escape
							/^(([^\s"(),.:;<>@[\\\]]+(\.[^\s"(),.:;<>@[\\\]]+)*)|(".+"))@((\[(?:\d{1,3}\.){3}\d{1,3}])|(([\da-z\-]+\.)+[a-z]{2,}))$/i,
						message: 'Please enter a valid email address'
					}
				}
			}
		});

		this.toggleBtn = SelectorEngine.findOne('.lta-officials-details__edit-cotact-toggle', this._container);
		const initialStatus = this.toggleBtn.querySelector('.lta-toggle--checkbox').checked;
		this.toggleStatus = initialStatus ? initialStatus : false;

		EventHandler.on(window, 'toggleStatus', (event) => {
			this.toggleStatus = event.detail.status;

		});

		this.fv.on('core.form.valid', () => {
			this.submitForm(this._form);
		});
	}

	backToUrl(event, redirectUrl) {
		const rootUrl = window.location.origin;
		const url = redirectUrl || event.currentTarget.dataset.target;
		window.location.href = `${rootUrl}${url}`;
	}

	async submitForm(form) {
		startLoadingAnimation(true);
		const dataObject = getDataFromForm(form);
		const payload = {
			updateOfficialsDetailsRequest: {
				MyEmailAddressDetails: {
					EmailAddress: dataObject.email,
					EmailAddressDetailsVisibility: this.toggleStatus
				}
			}
		};
        console.log(payload);
		try {
			const url = `/api/officials/update`;
			const responseData = await Request.post(url, payload);
			const { success } = responseData;
			if (success) {
				const redirectUrl = Manipulator.getDataAttribute(this._form, 'redirect-url');
				window.location.href = redirectUrl;
			} else {
				this._errorContainer.classList.remove('u-hidden');
			}
		} catch {
			this._errorContainer.classList.remove('u-hidden');
		} finally {
			stopLoadingAnimation();
		}
	}
}

const globalEditOfficialsDetails = new OfficialsEditEmailAddress();

export default globalEditOfficialsDetails;
